import React from 'react';

import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import { useTemplateDetailsStore } from '@store/templateDetailsStore';
import useAvailableLanguageOptions from '@hooks/useAvailableLanguageOptions';
import SelectInput from '@common/components/SelectInput/SelectInput';

import StarIcon from '@mui/icons-material/Star';
import { copyObjectWithoutRef } from '@common/helpers/helpers';

const CustomEmailEditorHeader = () => {
  const { t } = useTranslation();
  const availableLangOptions = useAvailableLanguageOptions();

  const setFormData = useTemplateDetailsStore((s) => s.setFormData);
  const currentLanguage = useTemplateDetailsStore((s) => s.currentLanguage);

  const onLangChange = (newLang) => {
    setFormData({ value: newLang, field: 'currentLanguage' });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        paddingLeft: '90px',
        justifyContent: 'flex-start',
        zIndex: 4,
        position: 'relative',
        borderBottom: '1px solid lightgrey',
        paddingBottom: '3px',
      }}
    >
      <SelectInput
        options={availableLangOptions.map((option) => {
          const optionCopy = copyObjectWithoutRef(option);
          if (optionCopy?.isDefault) {
            optionCopy.label = (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {t(optionCopy.label)}
                <StarIcon sx={{ fontSize: '13px' }} />
              </Box>
            );
          } else {
            optionCopy.label = t(optionCopy.label);
          }
          return optionCopy;
        })}
        accessors={{ valueAccessor: 'value', textAccessor: 'label' }}
        value={currentLanguage}
        onChange={(e) => onLangChange(e.target.value)}
        sx={{
          marginTop: '3px',
          fontSize: '13px',
          height: '30px',
          width: '150px',
          '& > div': {
            p: '4px 12px',
          },
          marginRight: '20px',
          marginLeft: 'auto',
        }}
      />
    </Box>
  );
};

export default CustomEmailEditorHeader;
